import axios from "axios";

export const getStatesByCountry = async (country) => {
  const response = await axios.post(
    "https://countriesnow.space/api/v0.1/countries/states",
    { country },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const fetchCountriesData = async () => {
  try {
    const res = await axios.post(
      "https://countriesnow.space/api/v0.1/countries/cities",
      {
        iso2: "IN",
      }
    );
    return res;
  } catch (error) {
    console.log("errror of cities api");
    return error | "Internal Server Error";
  }
};

export const getAllCountries = async () => {
  const response = await axios.get(
    "https://countriesnow.space/api/v0.1/countries"
  );
  return response.data;
};
export const getCitiesByState = async (country, state) => {
  try {
    if (!country || !state) return [];

    const response = await axios.post(
      "https://countriesnow.space/api/v0.1/countries/state/cities",
      {
        country: country.trim(),
        state: state.trim(),
      }
    );

    if (response.data?.error === false && Array.isArray(response.data.data)) {
      return response.data.data;
    }

    console.warn("No cities found:", response.data?.msg);
    return [];
  } catch (error) {
    console.error("Error fetching cities:", error?.response?.data || error);
    return [];
  }
};

